import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Spinner } from '../components/Spinner';
import type { UserRole } from '../constants/roles';
import { useAuth } from './useAuth';

export interface RequireAuthProps {
  children: ReactNode;
  roles?: readonly UserRole[];
}

export function RequireAuth({ children, roles }: RequireAuthProps) {
  const { user, loading, claims } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      // biome-ignore lint/a11y/useSemanticElements: <output> is form-bound; aria role="status" on a div is the canonical live-region pattern.
      <div
        role="status"
        aria-live="polite"
        className="flex min-h-screen items-center justify-center"
      >
        <Spinner />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (roles && roles.length > 0) {
    if (!claims.role || !roles.includes(claims.role)) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
